module.exports = __webpack_public_path__ + "static/media/heart-red.031ebf70.svg";